import {FieldRelationKind} from '../../enum/field.relation.kind';
import {FieldTypeKind} from '../../enum/field.type.kind';
import {EntityMananger} from './core.entity.mananger';

export function JoinColumn(type: FieldTypeKind, joinEntity: { new(...args: any[]): any },
                           allowNull: boolean, unique: boolean, relation: FieldRelationKind,
                           relationName: string, targetKey?: string, sourceKey?: string): PropertyDecorator {
    return (target: any, key: string) => {
        const metadata = EntityMananger.getEntityColumn(target.constructor.name, key);

        metadata.columnName = key;
        metadata.columnType = type;
        metadata.allowNull = allowNull;
        metadata.unique = unique;

        metadata.isForeignKey = true;
        metadata.targetKey = targetKey;
        metadata.sourceKey = sourceKey;
        metadata.joinEntity = joinEntity;
        metadata.hasOne = relation == FieldRelationKind.HAS_ONE;
        metadata.relation = relation;
        metadata.relationName = relationName;

        EntityMananger.registerEntityColumns(target.constructor.name, metadata);
    };
}
